<script setup lang="ts">
import { ref } from 'vue';
import { ModalDialog } from '@hfc/ui-core';
import { useUrlHelper } from '@/shared/infrastructure/composition/useUrlHelper';

const { getSmallBusinessQuoteReviewLink, getSmallBusinessConsultationPhone } = useUrlHelper();

const showConsultationModal = ref<boolean>(false);
</script>
<template>
  <div class="flex flex-row justify-start items-center">
    <p>Let us help. <a class="cursor-pointer mx-2" tabindex="-1" @click="showConsultationModal = true">Schedule a Consultation</a> <br class="sm:hidden" />or call <a class="ml-2" tabindex="-1" :href="`tel:${getSmallBusinessConsultationPhone()}`">{{ getSmallBusinessConsultationPhone() }}.</a></p>
  </div>
  <ModalDialog v-if="showConsultationModal == true" :show-confirm-button="false" size="xl" title="Let us help" @close="showConsultationModal = false">
    <template #content>
      <iframe class="w-full h-full md:min-h-[calc(50vh)] lg:-mt-16" style="zoom: 1.4;" :src="getSmallBusinessQuoteReviewLink()"></iframe>
    </template>
  </ModalDialog>
</template>
